<header class="header">
  <h1>-Hi, I'm Manasvi. 🤗</h1>
  <h3>
    software engineer, novice artist, and student at Rutgers University-New
    Brunswick.
  </h3>
</header>

<div class="grid-display">
  <div *ngFor="let project of projects" class="card">
    <a routerLink="/{{ project.key }}">
      <img
        [src]="project.imageUrl"
        class="post-image"
        width="600"
        height="300px"
      />

      <h3 class="title post-info">{{ project.name }}</h3>
      <div class="article-date">
        <span class="date">| {{ project.date }} |</span>
      </div>
      <p class="article-description">{{ project.description }}</p>
      <a routerLink="/{{ project.key }}" class="read-more">Learn More...</a>
    </a>
  </div>
</div>
